import { useMediaQuery } from "@mui/material";
import { usePostHog } from "posthog-js/react";
import { useEffect, useMemo, useState } from "react";
import { openEmployerSignUp } from "../../../helpers/elp_sign_up";
import {
  ButtonContainerStyled,
  ButtonStyled,
  ChildContainerLeft,
  GridContainerStyled,
  InternshipContainer,
  InternshipDescription,
  InternshipTitle,
  MoreInfoLink,
  ParentContainerLeft,
  ParentContainerRight,
} from "./styles";

import { assetDomain } from "../../../config/config";
import { getUtmQueryString } from "../../../helpers/utm";

const settings = {
  infinite: true,
  slidesToShow: 1.05,
  initialSlide: 0,
  autoplay: true,
  speed: 5000,
  autoplaySpeed: 0,
  cssEase: "linear",
  arrows: false,
  pauseOnHover: false,
  swipe: false,
  centerMode: true,
  centerPadding: "55px",
};

const universities = [
  {
    name: "Tunku Abdul Rahman University of Management and Technology",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/TARUMT.png",
  },
  {
    name: "Taylor's University",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/Taylor's.png",
  },
  {
    name: "University of Nottingham",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/Nottingham.png",
  },
  {
    name: "INTI University",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/INTI.png",
  },
  {
    name: "University Tunku Abdul Rahman",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/UTAR.png",
  },
  {
    name: "Monash University",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/Monash.png",
  },
  {
    name: "Sunway University",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/Sunway.png",
  },
  {
    name: "University of Malaya",
    image:
      "https://assets.wobbjobs.com/images/employer_landing/universities/UOM.png",
  },
];

// Create image arrays for different rows
const firstRowImages = [5, 0, 6, 7];
const secondRowImages = [2, 5, 1, 3];
const thirdRowImages = [1, 2, 7, 4];
const forthRowImages = [6, 4, 3, 0];

export default function EmployerInternships() {
  const posthog = usePostHog();
  const belowLg = useMediaQuery("(max-width: 1279px)");
  const mobileView = useMediaQuery("(max-width: 767px)");

  const [hidePostForFree, setHidePostForFree] = useState(false);

  useEffect(() => {
    setHidePostForFree(localStorage.getItem("posthogImage") === "hidden");
  }, []);

  const buttonColour = "yellow";
  const buttonCTA = `Post for Free`;

  const utm = getUtmQueryString();

  function triggerEmployerSignUp() {
    openEmployerSignUp({
      posthog,
      buttonCTA: buttonCTA,
      buttonColour: buttonColour,
      section: "free-jobs",
    });
  }

  const getCardsImage = () => {
    if (mobileView) {
      return "mobile_freemium_illustration";
    } else if (belowLg) {
      return "tablet_freemium_illustrations";
    } else {
      return "web_freemium_illustration";
    }
  };

  const cardsImage = useMemo(() => getCardsImage(), [mobileView, belowLg]);

  return (
    <GridContainerStyled>
      <InternshipContainer>
        <ParentContainerLeft>
          <ChildContainerLeft>
            {mobileView && (
              <ParentContainerRight
                bgImage={`${assetDomain}/images/employer_landing/${cardsImage}.png`}
              />
            )}
            <InternshipTitle>
              Still unsure? <br /> Try posting for <b>FREE!</b>
            </InternshipTitle>
            <InternshipDescription>
              Post Internships, Retail, F&B, and Hospitality roles for FREE —
              and find your next great hire today.
            </InternshipDescription>
          </ChildContainerLeft>

          <ButtonContainerStyled>
            <ButtonStyled onClick={triggerEmployerSignUp}>
              {buttonCTA}
            </ButtonStyled>

            {!hidePostForFree && (
              <>
                <MoreInfoLink
                  href={`/employer/retail-fnb-hospitality${utm}`}
                  color="inherit"
                >
                  Learn more
                </MoreInfoLink>
              </>
            )}
          </ButtonContainerStyled>
        </ParentContainerLeft>
        {!mobileView && (
          <ParentContainerRight
            bgImage={`${assetDomain}/images/employer_landing/${cardsImage}.png`}
          />
        )}
      </InternshipContainer>
    </GridContainerStyled>
  );
}
